import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Message, SelectItem } from 'primeng/api';
import { Empresa } from 'src/app/admihair/api/dto/empresa';
import { TributacaoEmpresa } from 'src/app/admihair/api/dto/tributacao-empresa';
import { TributacaoRecolhimento } from 'src/app/admihair/api/dto/tributacao-recolhimento';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { TributacaoEmpresaService } from 'src/app/admihair/service/tributacao-empresa.service';
import { TributacaoRecolhimentoService } from 'src/app/admihair/service/tributacao-recolhimento.service';

@Component({
  selector: 'app-tributacao-inserir',
  templateUrl: './tributacao-inserir.component.html',
  styleUrls: ['./tributacao-inserir.component.scss']
})
export class TributacaoInserirComponent implements OnInit {
  messages: Message[] = [{ severity: '', summary: '', detail: '' }];
  messagemVisivel: boolean = false;
  progressoRequisicao: boolean = false;
  opcoesCertificadoDigital: SelectItem[] = [{label: 'SIM', value: 'S',}, {label: 'NÃO', value: 'N'}];
  crts: SelectItem[] = [
    {label: 'SIMPLES NACIONAL', value: 'SIMPLES_NACIONAL'},
    {label: 'SN - EXCESSO SUBLIMITE', value: 'SN_EXCESSO_SUBLIMITE'},
    {label: 'REGIME NORMAL', value: 'REGIME_NORMAL'}
  ];
  tipoRegistros: String[] = ['DANFE', 'RPS'];
  tiposTributacaoR: TributacaoRecolhimento[] = [];
  tiposTributacaoT: TributacaoRecolhimento[] = [];
  statusTributo: boolean = false;
  ultimoDanfe: number = 0;
  ultimoRps: number = 0;
  aliquotaPadrao: number = 0;

  @Input() empresa?: Empresa;
  @Output() emissor = new EventEmitter();


  constructor(private tributacaoEmpresaService: TributacaoEmpresaService,
    private tributacaoRecolhimentoService: TributacaoRecolhimentoService,
    private erroService: ErroService) { }

  @ViewChild('f') form?: NgForm;

  ngOnInit(): void {
    this.carregarTiposTributacao();
    console.log(this.empresa)

  }


  salvar(){
    let tributacaoEmpresa: TributacaoEmpresa = this.form?.value;
    tributacaoEmpresa.empresaId = this.empresa?.id;
    tributacaoEmpresa.horaStatus = new Date().toISOString();
    tributacaoEmpresa.excluido = false;
    tributacaoEmpresa.moduloHabilitado = false;
    
    this.tributacaoEmpresaService.salvar(tributacaoEmpresa).subscribe({
      next: (data: TributacaoEmpresa) => {
        this.progressoRequisicao = false;
        this.messages = this.erroService.handleSuccess();
        this.messagemVisivel = true;
        this.rolarTela();
      },
      error: (err: any) => {
        this.progressoRequisicao = false;
        this.messages = this.erroService.handleErro(err);
        this.messagemVisivel = true;
        this.rolarTela();
        
      }
    });
  }

  carregarTiposTributacao(){
    this.tributacaoRecolhimentoService.listarTodos().subscribe({
      next: (data: TributacaoRecolhimento[]) => {
        this.tiposTributacaoR = data.filter(t => t.opcao === 'R');
        this.tiposTributacaoT = data.filter(t => t.opcao === 'T')
      },
      error: (err: any) => {
        console.log(err);
      }
    })
  }

  carregarTiposTributacaoT(){
    const opcaoTributo = 'T';
    this.tributacaoRecolhimentoService.listarPorOpcaoTributo(opcaoTributo).subscribe({
      next: (data: TributacaoRecolhimento[]) => {
        this.tiposTributacaoT = data;
      },
      error: (err: any) => {
        console.log(err);
      }
    })
  }

  voltar(){
    this.emissor.emit({
      modo: 'LISTAR'
    });
  }

  rolarTela(){
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }
  
  limparFormulario(){
    this.form?.reset(); 
  }
  
}
